export default {
  APPS: {
    SET_APP: 'SET_APP',
    SET_APPS: 'SET_APPS',
    SET_APP_DETAIL: 'SET_APP_DETAIL',
    UPDATE_APP: 'UPDATE_APP',
    SET_USER_APPS: 'SET_USER_APPS',
    SET_CURRENT_TEAM: 'SET_CURRENT_TEAM',
    CLEAR_USER_APPS: 'SET_USER_APPS',
    CLEAR_APP: 'CLEAR_APP',
    CLEAR_APPS: 'CLEAR_APPS',
    SET_CHILD_APP: 'SET_CHILD_APP',
    SET_APP_DESIGN: 'SET_APP_DESIGN',
    SET_APP_DESIGN_COLORS: 'SET_APP_DESIGN_COLORS',
    SET_APP_PARTICIPATION: 'SET_APP_PARTICIPATION',
    SET_APP_BEACON_CONFIG: 'SET_APP_BEACON_CONFIG',
    SET_BEACONS: 'SET_BEACONS',
    SET_BEACON: 'SET_BEACON',
    SET_BEACON_ACTIONS: 'SET_BEACON_ACTIONS',
    CLEAR_BEACONS: 'CLEAR_BEACONS',
  },
  AUTH: {
    REGISTER: 'REGISTER',
    LOGIN: 'LOGIN',
    FORGOT: 'FORGOT',
    LOGOUT: 'LOGOUT',
  },
  HTTP: {
    LOADING: 'LOADING',
    UPLOADING: 'UPLOADING',
    UPLOADINGEND: 'UPLOADINGEND',
    LOADED: 'LOADED',
    ERROR: 'ERROR',
    CLEAR_STATUS: 'CLEAR_STATUS',
  },
  LIBRARY: {
    SET_MEDIAS: 'SET_MEDIAS',
    SET_MEDIAS_TAG: 'SET_MEDIAS_TAG',
    SET_MEDIAS_TAG_SELECTED: 'SET_MEDIAS_TAG_SELECTED',
    SET_IMAGES: 'SET_IMAGES',
    CLEAR_MEDIAS: 'CLEAR_MEDIAS',
    UPLOAD_PROGRESS: 'UPLOAD_PROGRESS',
    UPLOAD_SUCCESS: 'UPLOAD_SUCCESS',
    UPLOAD_REINIT_STATUS: 'UPLOAD_REINIT_STATUS',
    SET_ICONS: 'SET_ICONS',
    RESET_ICONS: 'RESET_ICONS',
    SET_ICONS_TAG: 'SET_ICONS_TAG',
    SET_IMAGES_TAG: 'SET_IMAGES_TAG',
    RESET_IMAGES: 'RESET_IMAGES',
    SET_TOTAL_SIZE: 'SET_TOTAL_SIZE',
    SET_REPLACING: 'SET_REPLACING',
    UPDATE_MEDIA: 'UPDATE_MEDIA',
    UPDATE_MEDIA_TAGS: 'UPDATE_MEDIA_TAGS',
    SET_MEDIAS_FILTERED: 'SET_MEDIAS_FILTERED',
  },
  CONTENT: {
    SET_CONTENT: 'SET_CONTENT',
    GET_CONTENT_TAGS: 'GET_CONTENT_TAGS',
    SET_CONTENT_TAGS: 'SET_CONTENT_TAGS',
    SET_FULL_DETAIL_SECTIONS: 'SET_FULL_DETAIL_SECTIONS',
    SET_CONTENTS: 'SET_CONTENTS',
    SET_CONTENTS_POS: 'SET_CONTENTS_POS',
    CLEAR_CONTENT: 'CLEAR_CONTENT',
    CLEAR_CONTENTS: 'CLEAR_CONTENTS',
    SET_GENERIC_TYPES: 'SET_GENERIC_TYPES',
    SET_PERSONAL_TYPES: 'SET_PERSONAL_TYPES',
    SAVE_CONTENT: 'SAVE_CONTENT',
    SET_RA_TAGS: 'SET_RA_TAGS',
    SET_ADDRESS_BOOKS: 'SET_ADDRESS_BOOKS',
    CLEAR_ADDRESS_BOOKS: 'CLEAR_ADDRESS_BOOKS',
  },
  CONFIGURATION: {
    SET_NAVIGATION_TYPE: 'SET_NAVIGATION_TYPE',
  },
  DESIGN: {
    SET_COLOURLOVERS_PALETTES: 'SET_COLOURLOVERS_PALETTES',
    SET_SELECTED_PALETTE: 'SET_SELECTED_PALETTE',
    SET_COLORS: 'SET_COLORS',
    SET_MAPPING: 'SET_MAPPING',
    SET_FONTS: 'SET_FONTS',
    UPDATE_COLORS: 'UPDATE_COLORS',
  },
  USERS: {
    ADD_USER_TO_STORE: 'ADD_USER_TO_STORE',
    REMOVE_USER_FROM_STORE: 'REMOVE_USER_FROM_STORE',
    MODIFY_USER_FROM_STORE: 'MODIFY_USER_FROM_STORE',
    CLEAR_USERS: 'CLEAR_USERS',
    FETCH_USERS: 'FETCH_USERS',
    FETCH_GW_USERS: 'FETCH_GW_USERS',
    FETCH_OWNER_USERS: 'FETCH_OWNER_USERS',
    DETAIL_USER: 'DETAIL_USER',
    ADD_USER: 'ADD_USER',
    MODIFY_USER: 'MODIFY_USER',
    DELETE_USER: 'DELETE_USER',
    FETCH_GROUP: 'FETCH_GROUP',
    FETCH_GROUP_PAGE: 'FETCH_GROUP_PAGE',
    DETAIL_GROUP: 'DETAIL_GROUP',
    ADD_GROUP: 'ADD_GROUP',
    MODIFY_GROUP: 'MODIFY_GROUP',
    DELETE_GROUP: 'DELETE_GROUP',
    CLEAR_GROUPS: 'CLEAR_GROUPS',
  },
  LOCALES: {
    FETCH_LOCALES: 'FETCH_LOCALES',
  },
  CHAT: {
    SET_ROOMS: 'SET_ROOMS',
    SET_ROOM: 'SET_ROOM',
    CLEAR_ROOMS: 'CLEAR_ROOMS',
  },
  PLAN: {
    SET_PLANS: 'SET_PLANS',
    SET_PLAN: 'SET_PLAN',
  },
  MAP: {
    SET_MAPS: 'SET_MAPS',
    SET_LIST_MAPS: 'SET_LIST_MAPS',
    SET_MAP: 'SET_MAP',
    SET_TYPES: 'SET_TYPES',
    SET_VENUES: 'SET_VENUES',
    RESET_MAPS: 'RESET_MAPS',
  },
  TEAM: {
    SET_TEAM: 'SET_TEAM',
    ADD_MEMBER: 'ADD_MEMBER',
    REMOVE_MEMBER: 'REMOVE_MEMBER',
  },
  DEPLOY: {
    CERTIF: 'CERTIF',
    STORES: 'STORES',
    KEYSTORE: 'KEYSTORE',
  },
  ADMIN: {
    SET_ALL_APPS: 'SET_ALL_APPS',
    CLEAR_ALL_APPS: 'CLEAR_ALL_APPS',
    SET_USERS: 'SET_USERS',
    SET_PROFILES: 'SET_PROFILES',
    SET_APPS: 'SET_APPS',
    SET_AUTH_PROPERTIES: 'SET_AUTH_PROPERTIES',
    DETAIL_PROFIL: 'DETAIL_PROFIL',
  },
  ANALYTICS: {
    SET_DASHBOARD: 'SET_DASHBOARD',
    CLEAR: 'CLEAR',
    SET_EVENTS: 'SET_EVENTS',
    SET_EVENT_DATAS: 'SET_EVENT_DATAS',
  },
  NOTIF: {
    PREVIEW_NOTIF: 'PREVIEW_NOTIF',
    PREVIEW_NOTIF_ALL: 'PREVIEW_NOTIF_ALL',
    FETCH_NOTIF_LIST: 'FETCH_NOTIF_LIST',
    CLEAR_NOTIF_LIST: 'CLEAR_NOTIF_LIST',
    FETCH_HISTORY: 'FETCH_HISTORY',
    CLEAR_HISTORY: 'CLEAR_HISTORY',
  },
  API_KEY: {
    FETCH_API_KEYS: 'FETCH_API_KEYS',
    FETCH_AUTHORIZATIONS: 'FETCH_AUTHORIZATIONS',
    CLEAR_API_KEYS: 'CLEAR_API_KEYS',
  },
  DATASOURCES: {
    SET_KEY_VALUES_TYPES: 'SET_KEY_VALUES_TYPES',
    SET_API_KEY_VALUES_TYPES: 'SET_API_KEY_VALUES_TYPES',
    SET_KEY_VALUES: 'SET_KEY_VALUES',
    SET_API_KEY_VALUES: 'SET_API_KEY_VALUES',
    SET_FOLDER: 'SET_FOLDER',
    SET_FILES: 'SET_FILES',
    SET_PLANNERS: 'SET_PLANNERS',
    SET_CHECKINS: 'SET_CHECKINS',
    SET_CHATS: 'SET_CHATS',
    SET_RESOURCE_MANAGERS: 'SET_RESOURCE_MANAGERS',
    SET_FORMS: 'SET_FORMS',
    SET_DMS: 'SET_DMS',
    SET_GENERICS: 'SET_GENERICS',
  },
  FORMS: {
    FORM: {
      SELECT: 'FORM_SELECT',
      DELETE: 'FORM_DELETE',
      CREATE: 'FORM_CREATE',
      EDIT: 'FORM_EDIT',
      LOAD: 'FORM_LOAD',
      SAVE: 'FORM_SAVE',
      UPDATE: 'FORM_UPDATE',
    },
    FIELD: {
      SELECT: 'FIELD_SELECT',
      DELETE: 'FIELD_DELETE',
      CREATE: 'FIELD_CREATE',
      EDIT: 'FIELD_EDIT',
      MULTISELECT: 'FIELD_MULTI_SELECT',
    },
    RECORD: {
      SELECT: 'RECORD_SELECT',
      CREATE: 'RECORD_CREATE',
      DELETE: 'RECORD_DELETE',
      EDIT: 'RECORD_EDIT',
      UPDATE: 'RECORD_UPDATE',
      SORT: 'RECORD_SORT',
      FILTER: 'RECORD_FILTER',
      MULTISELECT: 'RECORD_MULTISELECT',
      LOAD: 'RECORD_LOAD',
    },
  },
}
